import { useLayoutEffect, useRef } from 'react'
import { IModal } from './props'
import { Body, Content, Header, Hr, ModalComponent, Title } from './styles'

const Modal = ({
  open,
  onClose,
  title,
  children,
  closeInClickOut,
}: IModal) => {
  const refContent = useRef<HTMLDivElement>(null)

  const onKeyDown = (e: KeyboardEvent) => {
    const isEscape = e.key === 'Escape'

    if (isEscape) onClose()
  }

  const onMouseDown = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (!closeInClickOut) return

    const isClickRight = e.button === 0
    const isOut = !(refContent?.current?.contains(e.target as Element))

    if (isClickRight && isOut) onClose()
  }

  useLayoutEffect(() => {
    if (open) {
      document.addEventListener('keydown', onKeyDown)
      document.body.style.overflow = 'hidden'
    }

    return () => {
      document.removeEventListener('keydown', onKeyDown)
      document.body.style.overflow = 'visible'
    }
  }, [open])

  if (!open) return null

  return (
    <ModalComponent
      onMouseDown={onMouseDown}
    >
      <Content ref={refContent}>
        <Header>
          <Title>{title}</Title>
          {/* <Icon
            name='close'
            onClick={onClose}
            pointer={true}
          /> */}
        </Header>

        <Body>
          {children}
        </Body>
      </Content>
    </ModalComponent>
  )
}

Modal.defaultProps = {
  title: '',
  closeInClickOut: true,
}

export default Modal